const parseParagraphs = (dataFromBraze) => {
    const isParagraphKey = (k) => /^paragraph\d$/.test(k);
    const orderedParagraphKeys = Object.keys(dataFromBraze)
        .filter(isParagraphKey)
        .sort();
    const paragraphs = [];
    for (const key of orderedParagraphKeys) {
        const value = dataFromBraze[key];
        if (value)
            paragraphs.push(value);
    }
    return paragraphs;
};
export const parseBrazeEpicParams = (dataFromBraze) => {
    const { heading, highlightedText, buttonText, buttonUrl } = dataFromBraze;
    if (!heading || !highlightedText || !buttonText || !buttonUrl) {
        console.log('Braze Epic: props missing', dataFromBraze);
        return null;
    }
    const paragraphs = parseParagraphs(dataFromBraze);
    if (paragraphs.length < 1) {
        console.log('Braze Epic: no valid paragraphs received', dataFromBraze);
        return null;
    }
    return {
        // name: 'BrazeEpic', // This may be useful for click tracking once we add it
        heading,
        paragraphs,
        highlightedText,
        cta: { text: buttonText, baseUrl: buttonUrl },
    };
};
